const INCOMPLETE_LINK_TAIL = /^\[[^\n\]]*(?:](?:\([^\n)]*)?)?$/;

function endsInsideCode(precedingText: string): boolean {
  const fences = precedingText.match(/```/g)?.length ?? 0;

  if (fences % 2 === 1) {
    return true;
  }

  const currentLine = precedingText.slice(precedingText.lastIndexOf('\n') + 1);
  const backticks = currentLine.match(/`/g)?.length ?? 0;

  return backticks % 2 === 1;
}

/**
 * Drops a markdown link (or image) that is still being written at the very
 * end of a streaming answer — `[label`, `[label]` or `[label](https://exa`.
 *
 * Until its closing `)` arrives the construct is not a link, so it renders as
 * raw `[label](url…` text and then reflows into a styled link in one jump.
 * Holding it back means the link only ever appears fully formed. Only the
 * unfinished tail is affected, and never inside code, where `[` is literal.
 */
export function holdBackIncompleteLink(text: string): string {
  const bracketIndex = text.lastIndexOf('[');

  if (bracketIndex === -1) {
    return text;
  }

  const startIndex =
    text[bracketIndex - 1] === '!' ? bracketIndex - 1 : bracketIndex;
  const preceding = text.slice(0, startIndex);

  if (!INCOMPLETE_LINK_TAIL.test(text.slice(bracketIndex))) {
    return text;
  }

  return endsInsideCode(preceding) ? text : preceding;
}
